<template>
	<div>
		<div layout="row" layout-wrap class="full-width" flex>
			<div layout="column" layout-align="start start" class="full-width pr2-pc pl2-pc mb10-pc pb1-pc mb1-mobile pr1-mobile pl1-mobile bg-white" :flex="$vuetify.breakpoint. smAndDown ? 100 : 35">
				<div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc mt1-mobile">{{$t('surveys.short_desc')}}</div>
				<div style="white-space: pre-wrap; word-wrap: break-word;font-family: inherit;" class="mt-2 pa-1">{{i18n(survey.description)}}</div>
			</div>
			<div layout="column" layout-align="start start" class="full-width pr2-pc pl2-pc mb10-pc pb1-pc mb1-mobile ml10-pc pr1-mobile pl1-mobile bg-white" flex>
				<div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc mt1-mobile">{{$t('surveys.post_mess')}}</div>
				<div style="white-space: pre-wrap; word-wrap: break-word;font-family: inherit;" class="mt-2 pa-1">{{survey.message.body}}</div>
			</div>
		</div>
		<div layout="row" layout-wrap class="full-width" flex>
			<div layout="column" layout-align="start start" class="full-width pr2-pc pl2-pc pb1-pc pr1-mobile pl1-mobile mb1-mobile bg-white" :flex="$vuetify.breakpoint. smAndDown ? 100 : 35">
				<div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc mt1-mobile full-width">
					<span>{{$t('surveys.target')}}</span>
					<span flex></span>
					<span class="font-weight-reguler body-2 text-lowercase">
						{{survey.nb_answers}} {{ (survey.nb_answers > 1) ? $t('surveys.answers') : $t('surveys.answer') }} / {{survey.nb_targets}} {{ (survey.nb_targets > 1) ? $t('surveys.targeted_ppl') : $t('surveys.targeted_pl') }}
					</span>
				</div>
				<div class="mt2-pc pa-1">
					<div layout="row" layout-align="start center" layout-wrap>
						<span :class="{'font-weight-bold' : (survey.message.levels.length && survey.message.levels.length != 4)}">{{$t('params.levels')}} :&nbsp;</span>
						<span v-if="!survey.message.levels.length  || survey.message.levels.length == 4">
							{{$t('_.all_m')}}
						</span>
						<span v-else>
							<span v-for="(l,i) in survey.message.levels" :key="l.id">
								<span v-if="(i != 0) && (i != (survey.message.levels.length - 1))">,&nbsp;</span>
								<span v-else-if="(i != 0) && (i == (survey.message.levels.length - 1))">&nbsp;{{$t('_.and')}}&nbsp;</span>
								{{levelLabel(l.level)}}
							</span>
						</span>
					</div>

					<div layout="row" layout-align="start center" layout-wrap>
						<span :class="{'font-weight-bold' : (survey.message.sectors.length && survey.message.sectors.length != 3)}">{{$t('params.sectors')}} :&nbsp;</span>
						<span v-if="!survey.message.sectors.length  || survey.message.sectors.length == 3">
							{{$t('_.all_m')}}
						</span>
						<span v-else>
							{{sectorLabel(survey.message.sectors[0].sector)}}
							<span v-if="survey.message.sectors[1]">
								{{$t('_.and')}} {{sectorLabel(survey.message.sectors[1].sector)}}
							</span>
						</span>
					</div>

					<div layout="row" layout-align="start center" layout-wrap>
						<span :class="{'font-weight-bold' : survey.message.regional_directorates.length}">{{$t('params.rds')}} :&nbsp;</span>
						<span v-if="!survey.message.regional_directorates.length">
							{{$t('_.all_f')}}
						</span>
						<span v-else>
							<span>{{i18n(survey.message.regional_directorates[0].label)}}</span><span v-if="survey.message.regional_directorates[1]">{{(survey.message.regional_directorates.length == 2) ? ' ' + $t('_.and') + ' ' : ', '}}{{i18n(survey.message.regional_directorates[1].label)}}
								<span v-if="survey.message.regional_directorates[2]">
									{{$t('_.and')}}
									<v-menu v-if="survey.message.regional_directorates.length > 3" v-model="rdsModal">
										<a slot="activator" href="#" >
											{{survey.message.regional_directorates.length - 2}} {{$t('_.more')}}
										</a>
										<v-card>
											<v-card-text>
												<v-data-table :items="survey.message.regional_directorates" hide-actions hide-headers dense class="full-width">
														<template v-if="props.index > 1" slot="items" slot-scope="props">
																<td>{{ i18n(props.item.label) }}</td>
														</template>
													</v-data-table>
											</v-card-text>
										</v-card>
									</v-menu>
									<span v-else>
										{{i18n(survey.message.regional_directorates[2].label)}}
									</span>
								</span>
							</span>
						</span>
					</div>

					<div layout="row" layout-align="start center" layout-wrap>
						<span :class="{'font-weight-bold' : survey.message.regions.length}">{{$t('params.regions')}} :&nbsp;</span>
						<span v-if="!survey.message.regions.length">
							{{$t('_.all_f')}}
						</span>
						<span v-else>
							<span>{{i18n(survey.message.regions[0].name)}}</span><span v-if="survey.message.regions[1]">{{(survey.message.regions.length == 2) ? ' ' + $t('_.and') + ' ' : ', '}}{{i18n(survey.message.regions[1].name)}}
								<span v-if="survey.message.regions[2]">
									{{$t('_.and')}}
									<v-menu v-if="survey.message.regions.length > 3" v-model="regionsModal">
										<a slot="activator" href="#" >
											{{survey.message.regions.length - 2}} {{$t('_.more')}}
										</a>
										<v-card>
											<v-card-text>
												<v-data-table :items="survey.message.regions" hide-actions hide-headers dense class="full-width">
														<template v-if="props.index > 1" slot="items" slot-scope="props">
																<td>{{ i18n(props.item.name) }}</td>
														</template>
												</v-data-table>
											</v-card-text>
										</v-card>
									</v-menu>
									<span v-else>
										{{i18n(survey.message.regions[2].name)}}
									</span>
								</span>
							</span>
						</span>
					</div>

					<div layout="row" layout-align="start center" layout-wrap>
						<span :class="{'font-weight-bold' : survey.message.cities.length}">{{$t('params.cities')}} :&nbsp;</span>
						<span v-if="!survey.message.cities.length">
							{{$t('_.all_f')}}
						</span>
						<span v-else>
							<span>{{survey.message.cities[0].label}}</span><span v-if="survey.message.cities[1]">{{(survey.message.cities.length == 2) ? ' ' + $t('_.and') + ' ' : ', '}}{{survey.message.cities[1].label}}
								<span v-if="survey.message.cities[2]">
									{{$t('_.and')}}
									<v-menu v-if="survey.message.cities.length > 3" v-model="citiesModal">
										<a slot="activator" href="#" >
											{{survey.message.cities.length - 2}} {{$t('_.more')}}
										</a>
										<v-card>
											<v-card-text>
												<v-data-table :items="survey.message.cities" hide-actions hide-headers dense class="full-width">
														<template v-if="props.index > 1" slot="items" slot-scope="props">
																<td>{{ props.item.label }}</td>
														</template>
												</v-data-table>
											</v-card-text>
										</v-card>
									</v-menu>
									<span v-else>
										{{survey.message.cities[2].label}}
									</span>
								</span>
							</span>
						</span>
					</div>

					<div layout="row" layout-align="start center" layout-wrap>
						<span :class="{'font-weight-bold' : survey.message.schools.length}">{{$t('schools.title')}} :&nbsp;</span>
						<span v-if="!survey.message.schools.length">
							{{$t('_.all_f')}}
						</span>
						<span v-else>
							<span>{{survey.message.schools[0].name}}</span><span v-if="survey.message.schools[1]">{{(survey.message.schools.length == 2) ? ' ' + $t('_.and') + ' ' : ', '}}{{survey.message.schools[1].name}}
								<span v-if="survey.message.schools[2]">
									{{$t('_.and')}}
									<v-menu v-if="survey.message.schools.length > 3" v-model="schoolsModal">
										<a slot="activator" href="#" >
											{{survey.message.schools.length - 2}} {{$t('_.more')}}
										</a>
										<v-card>
											<v-card-text>
												<v-data-table :items="survey.message.schools" hide-actions hide-headers dense class="full-width">
													<template v-if="props.index > 1" slot="items" slot-scope="props">
															<td>{{ props.item.name }}</td>
													</template>
												</v-data-table>
											</v-card-text>
										</v-card>
									</v-menu>
									<span v-else>
										{{survey.message.schools[2].name}}
									</span>
								</span>
							</span>
						</span>
					</div>
				</div>
			</div>

			<div layout="column" layout-align="start start" class="full-width pr2-pc pl2-pc pb1-pc ml10-pc mb1-mobile pr1-mobile pl1-mobile bg-white" :flex="$vuetify.breakpoint. smAndDown ? 100 : 20">
				<div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc mt1-mobile">{{$t('_.dates')}}</div>
				<div v-if="survey.message.date_start && survey.message.date_end" layout="column" layout-align="center center" class="mt-2 pa-1 full-width">
					<div>{{$t('_.from')}}</div>
					<div class="display-1 font-weight-bold grey--text">{{formatDay(survey.message.date_start)}}</div>
					<div class="grey--text font-weight-bold">{{formatMonthHumanI18n(survey.message.date_start)}}</div>
					<div>{{$t('_.to')}}</div>
					<div class="display-1 font-weight-bold grey--text">{{formatDay(survey.message.date_end)}}</div>
					<div class="grey--text font-weight-bold mb-1">{{formatMonthHumanI18n(survey.message.date_end)}}</div>
				</div>
				<div v-else layout="column" layout-align="center center" class="mt-2 pa-1 full-width">
					<div class="display-1 font-weight-bold grey--text">-</div>
				</div>
			</div>

			<div layout="column" layout-align="start start" class="full-width pr2-pc pl2-pc pb1-pc ml10-pc pr1-mobile pl1-mobile bg-white" flex>
				<div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc mt1-mobile">{{$t('surveys.thx')}}</div>
				<div style="white-space: pre-wrap; word-wrap: break-word;font-family: inherit;" class="mt-2 pa-1">{{i18n(survey.thanks)}}</div>
			</div>
		</div>
	</div>
</template>

<script>
    import Consts from '@/consts'
    import I18nMixin from '@/mixins/i18n'

    export default {
        mixins: [I18nMixin],
        props: {
            survey: {
							required: true,
							type: Object,
							default () {
								return {message: {}};
							}
            }
        },
        data () {
            return {
							schoolsModal: false,
							regionsModal: false,
							rdModal: false,
							citiesModal: false
            }
        },
        mounted () {

        },
        methods: {
					sectorLabel(s){
							switch (s) {
									case Consts.PRIMARY:
											return this.$t('schools.sector_prim');
									case Consts.SECONDARY:
											return this.$t('schools.sector_sec');
									case Consts.COMPETENCECENTRE:
											return this.$t('schools.sector_comp');
							}
					},
					levelLabel(l){
                switch(l) {
                    case Consts.MINISTRY:
                        return this.$t('users.lv_min');
                    case Consts.NATIONAL:
                        return this.$t('users.lv_nat');
                    case Consts.SECTORAL:
                        return this.$t('users.lv_sec');
                    case Consts.LOCAL:
                        return this.$t('users.lv_loc');
                }
            },
        },
        computed: {

        }
    }
</script>
<style scoped>
</style>